import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const ToolbarSplatScaleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M9.63 8H8.62C8.27758 8 8 8.27758 8 8.62V9.63C8 9.97242 8.27758 10.25 8.62 10.25H9.63C9.97242 10.25 10.25 9.97242 10.25 9.63V8.62C10.25 8.27758 9.97242 8 9.63 8Z"
        fill={color}
      />
      <path
        d="M9.63 13.75H8.62C8.27758 13.75 8 14.0276 8 14.37V15.38C8 15.7224 8.27758 16 8.62 16H9.63C9.97242 16 10.25 15.7224 10.25 15.38V14.37C10.25 14.0276 9.97242 13.75 9.63 13.75Z"
        fill={color}
      />
      <path
        d="M15.38 13.75H14.37C14.0276 13.75 13.75 14.0276 13.75 14.37V15.38C13.75 15.7224 14.0276 16 14.37 16H15.38C15.7224 16 16 15.7224 16 15.38V14.37C16 14.0276 15.7224 13.75 15.38 13.75Z"
        fill={color}
      />
      <path
        d="M15.38 8H14.37C14.0276 8 13.75 8.27758 13.75 8.62V9.63C13.75 9.97242 14.0276 10.25 14.37 10.25H15.38C15.7224 10.25 16 9.97242 16 9.63V8.62C16 8.27758 15.7224 8 15.38 8Z"
        fill={color}
      />
      <path
        d="M12.51 10.88H11.5C11.1576 10.88 10.88 11.1576 10.88 11.5V12.51C10.88 12.8524 11.1576 13.13 11.5 13.13H12.51C12.8524 13.13 13.13 12.8524 13.13 12.51V11.5C13.13 11.1576 12.8524 10.88 12.51 10.88Z"
        fill={color}
      />
      <path
        d="M22.3 5.8C22.56 6.06 23 5.88 23 5.51V1.69C23 1.31 22.69 1 22.31 1H18.49C18.12 1 17.94 1.44 18.2 1.7L19.8 3.3L18.68 4.41C16.89 2.83 14.55 1.86 11.99 1.86C9.43 1.86 7.08 2.83 5.3 4.41L4.19 3.3L5.79 1.7C6.05 1.44 5.87 1 5.5 1H1.69C1.31 1 1 1.31 1 1.69V5.51C1 5.88 1.44 6.06 1.7 5.8L3.3 4.2L4.41 5.31C2.83 7.1 1.86 9.44 1.86 12C1.86 14.56 2.83 16.91 4.41 18.69L3.3 19.81L1.7 18.21C1.44 17.95 1 18.13 1 18.5V22.32C1 22.7 1.31 23.01 1.69 23.01H5.51C5.88 23.01 6.06 22.57 5.8 22.31L4.2 20.71L5.31 19.6C7.1 21.18 9.44 22.15 12 22.15C14.56 22.15 16.91 21.18 18.69 19.6L19.8 20.71L18.2 22.31C17.94 22.57 18.12 23.01 18.49 23.01H22.31C22.69 23.01 23 22.7 23 22.32V18.5C23 18.13 22.56 17.95 22.3 18.21L20.7 19.81L19.59 18.7C21.17 16.91 22.14 14.57 22.14 12.01C22.14 9.45 21.17 7.1 19.59 5.32L20.7 4.21L22.3 5.81V5.8ZM21.12 12C21.12 14.29 20.27 16.38 18.87 17.99L18.4 17.52C18.16 17.28 17.76 17.28 17.52 17.52C17.28 17.76 17.28 18.16 17.52 18.4L17.99 18.87C16.39 20.27 14.3 21.12 12 21.12C9.7 21.12 7.62 20.26 6.01 18.87L6.48 18.4C6.72 18.16 6.72 17.76 6.48 17.52C6.24 17.28 5.84 17.28 5.6 17.52L5.13 17.99C3.73 16.39 2.88 14.29 2.88 12C2.88 9.71 3.74 7.62 5.13 6.01L5.6 6.48C5.84 6.72 6.24 6.72 6.48 6.48C6.72 6.24 6.72 5.84 6.48 5.6L6.01 5.13C7.61 3.73 9.71 2.88 12 2.88C14.29 2.88 16.38 3.73 17.99 5.13L17.52 5.6C17.28 5.84 17.28 6.24 17.52 6.48C17.76 6.72 18.16 6.72 18.4 6.48L18.87 6.01C20.27 7.61 21.12 9.71 21.12 12Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolbarSplatScaleIcon.displayName = 'ToolbarSplatScaleIcon';
